/**
 * Convert a string to a valid URL slug.
 * - Lowercase
 * - Replace spaces & special chars with hyphens
 * - Remove leading/trailing hyphens
 * - Collapse multiple hyphens
 */
export function slugify(value) {
  return value
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')       // spaces → hyphens
    .replace(/[^a-z0-9-]/g, '') // remove non-alphanumeric (except hyphens)
    .replace(/-+/g, '-')        // collapse multiple hyphens
    .replace(/^-+/, '')         // trim leading hyphens
    .replace(/-+$/, '');        // trim trailing hyphens
}

/**
 * Validate a slug — must not contain spaces or uppercase.
 */
export function isValidSlug(value) {
  return /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(value);
}